
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weingut/sortiment",
      function () {
        return require("private-next-pages/weingut/sortiment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weingut/sortiment"])
      });
    }
  